import { Play } from "lucide-react";
import { TypePill } from "@/components/Badges";
import { STATUS_LABEL } from "@/lib/constants";
import { resolveMediaUrl, thumbUrl } from "@/components/FileUpload";

// Premium dark media preview card (A-part of the design)
export function MediaCard({ item, onClick }) {
  const hasHot = item.flags?.includes("hot");
  return (
    <button
      data-testid={`media-card-${item.id}`}
      onClick={onClick}
      className="dark-panel group text-left rounded-2xl overflow-hidden bg-neutral-900 shadow-[0_2px_12px_rgba(0,0,0,0.15)] hover:shadow-xl transition-all duration-200 hover:-translate-y-1"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-neutral-800">
        {item.media_url ? (
          <img
            src={thumbUrl(item.media_url, 640)}
            alt={item.title}
            className="h-full w-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-neutral-600">
            <Play className="h-10 w-10" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-black/30" />
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <TypePill type={item.content_type} />
          {hasHot && (
            <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded bg-red-600 text-white">
              Heiß
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3.5">
          <div className="text-[10px] font-semibold uppercase tracking-wider text-white/60 mb-1">
            {STATUS_LABEL[item.status]}
          </div>
          <h4 className="font-head font-semibold text-white text-sm leading-snug line-clamp-2">{item.title}</h4>
          {item.hook && <p className="text-[12px] text-white/70 mt-1 line-clamp-2">{item.hook}</p>}
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="h-12 w-12 rounded-full bg-white/95 flex items-center justify-center">
            <Play className="h-5 w-5 text-neutral-900 fill-neutral-900 ml-0.5" />
          </span>
        </div>
      </div>
    </button>
  );
}
